import {
    ComponentCreateRequestRequestPriority,
    type CreateComponentCreateRequestRawInput,
    type UpdateComponentCreateRequestRawInput,
} from '@gql/graphql';
import { type NewComponentRequestFormValue } from '../components/NewComponentRequestForm';

type ComponentCreateRequestInput =
    | CreateComponentCreateRequestRawInput
    | UpdateComponentCreateRequestRawInput;

function createComponentVendorParams(
    formValue: Partial<NewComponentRequestFormValue>,
): Partial<ComponentCreateRequestInput> {
    if (typeof formValue.componentVendor === 'string') {
        return {
            componentVendorName: formValue.componentVendor,
            componentVendorID: null,
        };
    }

    if (formValue.componentVendor?.label) {
        return {
            componentVendorID: formValue.componentVendor.value,
            componentVendorName: null,
        };
    }

    return {
        componentVendorName: '',
    };
}

export function mapFormValueToRequestInput(
    formValue: Partial<NewComponentRequestFormValue>,
): ComponentCreateRequestInput {
    return {
        ...(formValue.id && { id: formValue.id }),
        ...createComponentVendorParams(formValue),
        componentName: formValue.componentName ?? '',
        componentVersion: formValue.componentVersion ?? '',
        requestPriority:
            formValue.requestPriority ??
            ComponentCreateRequestRequestPriority.Low,
        referenceWeb: formValue.referenceWeb,
        referenceSecurity: formValue.referenceSecurity,
    } as ComponentCreateRequestInput;
}
